import { MessageHeader, ProfileType } from "../../Types/LayoutTypes";

export const cartHeaderData = [
    {
        id: 1,
        src: 'headphone.png',
        name: 'Headphone'
    },
    {
        id: 2,
        src: 'wireless-headphone.png',
        name: 'AirPods'
    },
]


export const messageHeaderData: MessageHeader[] = [
    {
        id: 1,
        src: '3.jpg',
        name: 'Helen Walter',
        text: 'Do you want to go see movie?'
    },
    {
        id: 2,
        src: '6.jpg',
        name: 'Jason Borne',
        text: 'Thank you for rating us.'
    },
    {
        id: 3,
        src: '10.jpg',
        name: 'Sarah Loren',
        text: 'What`s the project report update?'
    },
];

export const profileHeaderData: ProfileType[] = [
    {
        id: 1,
        url: 'applications/users/user-profile',
        icon: 'User',
        text: 'Account',
    },
    {
        id: 2,
        url: 'applications/email/letter-box',
        icon: 'Mail',
        text: 'Inbox',
    },
    {
        id: 3,
        url: 'applications/task',
        icon: 'FileText',
        text: 'Taskboard',
    },
    {
        id: 4,
        url: 'applications/users/edit-profile',
        icon: 'Settings',
        text: 'Settings',
    }
]

export const languagesData = [
    {
        data: "en",
        language: "English",
    },
    {
        data: "du",
        language: "Deutsch",
    },
    {
        data: "es",
        language: "Español",
    },
    {
        data: "fr",
        language: "Français",
    },
    {
        data: "pt",
        language: "Português",
    },
    {
        data: "cn",
        language: "简体中文",
    },
    {
        data: "ae",
        language: "لعربية",
    },
];